<template>
  <div class="contactUs">
    <b-row>
      <b-col class="mx-auto" cols="10">
        <b-row>
          <b-col
            col
            lg="7"
            md="8"
            sm="8"
            style="margin-top: 5%; background-color: #fbfbfc"
            class="mx-auto d-none d-md-block"
          >
            <h3 class="contact-us-header">Ways to reach us</h3>

            <hr />
            <br />

            <div class="contacts">
              <div class="contact-medium">
                <b-row>
                  <b-img
                    class="glyph"
                    :src="require('../assets/ic_address.png')"
                  />
                  <div>
                    <b-row>
                      <span class="contact-header">Address</span>
                    </b-row>
                    <b-row>
                      <span class="contact"> PLOT 35, KAMPALA ROAD </span>
                    </b-row>
                  </div>
                </b-row>
              </div>

              <div class="contact-medium">
                <b-row>
                  <b-img
                    class="glyph"
                    :src="require('../assets/ic_phone.png')"
                  />
                  <div>
                    <b-row>
                      <span class="contact-header">Contact Number</span>
                    </b-row>
                    <b-row>
                      <span class="contact"> +256-414-255511 </span>
                    </b-row>
                  </div>
                </b-row>
              </div>

              <div class="contact-medium">
                <b-row>
                  <b-img
                    class="glyph"
                    :src="require('../assets/ic_email.png')"
                  />
                  <div>
                    <b-row>
                      <span class="contact-header">Email Address</span>
                    </b-row>
                    <b-row>
                      <span class="contact"> info@epostalsys.com </span>
                    </b-row>
                  </div>
                </b-row>
              </div>

              <div class="contact-medium">
                <b-row>
                  <b-img
                    class="glyph"
                    :src="require('../assets/ic_website.png')"
                  />
                  <div>
                    <b-row>
                      <span class="contact-header">Website</span>
                    </b-row>
                    <b-row>
                      <span class="contact"> www.ugapost.co.ug </span>
                    </b-row>
                  </div>
                </b-row>
              </div>
            </div>
          </b-col>

          <b-col
            col
            lg="4"
            md="8"
            sm="10"
            class="mx-auto"
            style="margin-top: 5%; margin-bottom: 5%"
          >
            <b-card class="contactCard">
              <b-form @submit="sendContactData">
                <h5 style="color: #db0000" class="text-center">
                  Leave us a message and <b>ePosta</b>,
                </h5>
                <b-card-text style="font-size: 14px" class="text-center"
                  >Promises to respond</b-card-text
                >
                <br />

                <div class="form-group mb-3 input-group input-text-wrapper">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                      style="background-color: #ffffff; border: none"
                    >
                      <font-awesome-icon icon="user" style="color: #ced4da" />
                    </span>
                  </div>
                  <b-form-input
                    class="contact-text-input"
                    id="input-email"
                    v-model="name"
                    type="text"
                    required
                    placeholder="Name"
                  ></b-form-input>
                </div>

                <div class="form-group mb-3 input-group input-text-wrapper">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                      style="background-color: #ffffff; border: none"
                    >
                      <font-awesome-icon
                        icon="envelope"
                        style="color: #ced4da"
                      />
                    </span>
                  </div>
                  <b-form-input
                    class="contact-text-input"
                    id="input-email"
                    v-model="email"
                    type="email"
                    required
                    placeholder="Email"
                  ></b-form-input>
                </div>

                <div class="form-group mb-3 input-group input-text-wrapper">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                      style="background-color: #ffffff; border: none"
                    >
                      <font-awesome-icon
                        icon="envelope"
                        style="color: #ced4da"
                      />
                    </span>
                  </div>
                  <b-form-input
                    class="contact-text-input"
                    id="input-email"
                    v-model="subject"
                    type="text"
                    required
                    placeholder="Subject"
                  ></b-form-input>
                </div>

                <b-form-group class="input-text-wrapper">
                  <b-form-textarea
                    class="contact-text-input"
                    v-model="message"
                    type="text"
                    required
                    placeholder="Message"
                  >
                  </b-form-textarea>
                </b-form-group>

                <b-form-group>
                  <b-button class="form-control contactButtonCard" type="submit"
                    >Send Message &nbsp;
                    <b-spinner
                      v-if="contactSpinner"
                      small
                      label="Loading..."
                    ></b-spinner>
                  </b-button>
                </b-form-group>
              </b-form>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {
      name: null,
      email: null,
      subject: null,
      message: null,
      contactSpinner: false,
    };
  },
  methods: {
    sendContactData(evt) {
      evt.preventDefault();
      alert("contactus");
    },
  },
};
</script>

<style scoped>
.contact-text-input {
  border: none;
  font-size: 13px;
  color: #8898aa;
}

.contactButtonCard {
  border: none;
  color: #ffffff;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  font-weight: bold;
  background: #db0000;
  height: 45px;
  border-radius: 3px;
  text-align: center;
  font-size: 15px;
  margin-top: 3%;
}

.input-text-wrapper {
  border: #ced4da 1px solid;
  padding: 5px;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 5px;
}

.contactCard {
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
}

.contactUs {
  width: 100%;
  height: 100%;
  /*background-color: #c40000;
  background-size: cover;*/
}

.box {
  border-radius: 6px;
  margin: 50px;
  box-shadow: 8px 10px 28px #8a0010;
}

.left {
  width: 50%;
  height: 100%;
  background-color: #db0000;
  background-size: cover;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.right {
  width: 50%;
  height: 100%;
  background-color: #fff;
  background-size: cover;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.title-bar {
  background: #db0000;
  padding: 15px;
}

.links {
  text-decoration: none;
  color: #fff;
  list-style: none;
}

.links li {
  padding: 5px;
  display: inline;
}

.links .active {
  background: #9f0012;
  border-radius: 10px;
  padding: 9px;
}

.links li:hover {
  background: #9f0012;
  border-radius: 10px;
  padding: 9px;
}

li a {
  color: white;
  text-decoration: none;
}

.logo {
  width: 100px;
  height: 30px;
}

.glyph {
  width: 60px;
  height: 60px;
  background: #c20012;
  border-radius: 32px;
  padding: 15px;
  margin-right: 25px;
}

.salutations {
  margin-top: 40px;
}

.contact-us-header {
  margin-top: 15px;
  margin-left: 20px;
  font-weight: bold;
}

.contacts {
  margin-top: 15px;
  margin-left: 20px;
  margin-right: 10px;
}

.contact-medium {
  margin-bottom: 30px;
}

.contact-header {
  margin-top: 3px;
  font-size: 16px;
  font-weight: bold;
}

.contact {
  font-size: 14px;
}

.form {
  width: 100%;
  margin-top: 35px;
  margin-left: 15px;
  margin-right: 15px;
}

.input {
  width: 100%;
  margin-bottom: 10px;
  border-radius: 0;
  border-bottom: solid 2px #db0000;
  border-top: 0;
  border-right: 0;
  border-left: 0;
  background: white;
}

.input:hover {
  border-top: 0;
  border-right: 0;
  border-left: 0;
  border-bottom: solid 2px #9f0012;
}

.input:focus {
  border-top: 0;
  border-right: 0;
  border-left: 0;
  border-bottom: solid 2px #9f0012;
}

.btns {
  width: 90%;
}

.text1 {
  font-size: 18px;
  color: #db0000;
  font-weight: 400;
}

.text2 {
  font-size: 18px;
  color: #4b4b4b;
}

.disclaimer {
  margin-top: 50px;
}

.button {
  width: 100%;
  background: #db0000;
  border: none;
  border-radius: 2px;
  color: #fff;
  padding: 8px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
}

.button:hover {
  background: #9f0012;
}
</style>
